module.exports = __webpack_public_path__ + "img/malla hexagonal.d97079ff.jpg";